import { Storage } from './storage';
import { CustomFilters } from './../logic/custom-filters';

export const customFiltersStorage = new Storage<CustomFilters>('/api/customFilters', 'customFilters', CustomFilters.default(), false);
